import { useCustomToast } from '@nexelem/snackbar';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useAPI } from '@nexelem/api';

export const useStorages = (inputValue: string, enabled?: boolean) => {
  const { t } = useTranslation();
  const api = useAPI();
  const displayToast = useCustomToast();

  return useQuery({
    queryKey: ['storage-select', inputValue],
    queryFn: () =>
      api.getBackPlacesSearch({
        text: inputValue,
        maxResults: 200,
      }),
    throwOnError: () => {
      displayToast({
        toastType: 'error',
        message: t('components.toasts.commonMessage.error'),
      });
      return false;
    },
    select: (response) =>
      (response ?? []).map(({ name, id }) => {
        return {
          key: name,
          value: id,
        };
      }),
    enabled,
  });
};
